export interface TagConfig {
  id?: string;
  type?: 'button'; // type of the tag
  label?: string; // label of the tag
  size?: 'sm' | 'md' | 'lg'; // size of the tag
  tagColor?: 'tag-primary' | 'tag-accent' | 'tag-success' | 'tag-error' | 'tag-warning'; // background color of the tag
  icon?: string; // icon url
  tags?: { label: string; visible?: boolean, icon?: string, id?: string }[]; // for multiple tags
  isIcon?: boolean; 
}

export const DEFAULT_TAG_CONFIG: TagConfig = {
  id : '',
  type: 'button',
  label: '',
  size: 'md',
  tagColor: 'tag-accent',
  icon: '',
  tags: [{ label: '', visible: true, icon: '', id: '' }],
  isIcon: true
};